const uris = {
  apiBase: process.env.REACT_APP_API_BASE,
  auth: 'auth',
  organization: 'organization',
  organizationJoin: 'organization/join',
  account: 'account',
  audience: 'audience',
  campaign: 'campaign',
  template: 'template',
  stats: 'stats'
}

export default uris
